module.exports = __webpack_public_path__ + "img/labmem_icon_weibo.5bc40701.png";